export default function checkPerMaxURL() {
  if (typeof window === "undefined") {
    return null;
  }
  const paramKey = "_camapign_type";
  const urlParams = new URLSearchParams(window.location.search);
  const paramUrlFlag = urlParams.get(paramKey);

  return paramUrlFlag;
}

export function checkAndComparePMaxValue() {
  // Call the original function to get the value of paramUrlFlag
  const perMaxUrlValue = checkPerMaxURL();
  const pMaxValue = "pmax";
  const paramValue = perMaxUrlValue === pMaxValue;

  return paramValue;
}
